import React from 'react';
import {
  FDStack,
  FDImage, FDHeadlineText,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverrideLite, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';

const metaOverrides = buildFacetDesignOverrideLite()
  .nameOverride(['benefitTitle'], {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'md',
      color: 'textSecondary',
    },
  }, overrideReadOnly);

const UpgradeOfferBenefit = ({ resource }) => {
  return (
    <FDStack direction={'column'} spacing={3}>
      {resource.withRelationship(fr.relationships.image.name, (rel) => (
        <FDImage src={rel.link('related').url()} alt={rel.meta('altText') || ''} />
      ), () => null)}
      <MetaControl attrName={'benefitTitle'} resource={resource} metaOverrideSet={metaOverrides} />
      <MetaControl attrName={'benefitDescription'} resource={resource} metaOverrideSet={metaOverrides} />
    </FDStack>
  );
};

export { UpgradeOfferBenefit };
